import { useRouter } from 'next/router';

export function useIsEditPage() {
  const router = useRouter();
  return !!router?.query?.edit;
}
